import { Route, Routes } from 'react-router-dom';
import Loadable from '../Components/Theme/Loadable';
import { lazy } from 'react';

const InstructionsPage = Loadable(lazy(() => import('../Pages/Guest/QuestionnaireWizard/InstructionsPage')));
const Questionnaire = Loadable(lazy(() => import('../Pages/Guest/QuestionnaireWizard/index')));
const ResultsPage = Loadable(lazy(() => import('../Pages/Guest/QuestionnaireWizard/ResultsPage')));
const DigitalMaturity = Loadable(lazy(() => import('../Pages/Guest/DigitalMaturity')));
const BookingFactor = Loadable(lazy(() => import('../Pages/Guest/BookingFactor')));
const BookingFactorForm = Loadable(lazy(() => import('../Pages/BookingFactor/BookingFactorForm')));
const BookingResults = Loadable(lazy(() => import('../Pages/BookingFactorResults/BookingFactorResults')));

const GuestRoutes = () => (
    <Routes>
        <Route exact path="/" element={<InstructionsPage />} />
        <Route exact path="/digital-maturity" element={<DigitalMaturity />} />
        <Route exact path="/booking-factor" element={<BookingFactor />} />
        <Route exact path="/Benchmarking-tool" element={<Questionnaire />} />
        <Route exact path="/results" element={<ResultsPage />} />
        <Route exact path="/booking-benchmarking-tool" element={<BookingFactorForm />} />
        <Route exact path="/booking-results" element={<BookingResults />} />
    </Routes>
);

export default GuestRoutes;
